<style scoped lang="scss">
  @import "../user";
  .card{
    border:1px solid #E4E6EA;
    padding:0 20px;
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #014492;
      padding:15px 0;
      border-bottom: 1px solid #E4E6EA;
    }
    .con{
      padding:15px 0;
    }
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">课题组基础信息<span :style="{fontSize: '14px', marginLeft: '20px', cursor: 'pointer'}"><a @click="viewContract">《服务协议》</a></span></h3>
      <ul class="info-lists">
        <li><span><label>课题组名称：</label>{{details.name}}</span></li>
        <li><span><label>发票抬头：</label>{{details.invoiceTitle}}</span></li>
        <li><span><label>PI/联系人姓名：</label>{{details.leaderName}}</span></li>
        <li><span><label>单位名称：</label>{{details.workUnit.name}}</span></li>
        <li><span><label>PI/联系人手机号：</label>{{details.leaderMobile}}</span></li>
        <li><span><label>单位地址：</label>{{address}}</span></li>
        <li><span><label>PI/联系人邮箱：</label>{{details.leaderEmail}}</span></li>
        <li><span><label>所属基地：</label>{{details.base.name}}</span></li>
        <li><span><label>创建时间：</label>{{details.createTime}}</span></li>
        <li><span><label>组长：</label>{{details.headMan ? details.headMan.realName : ''}}</span></li>
        <li><span><label>COA模版：</label>{{details.coaTemplateName}}</span></li>
      </ul>
    </section>
    <section v-if="details.clearAccountInfo">
      <h3 class="title">商务合作信息</h3>
      <el-row :gutter="40">
        <el-col :span="8">
          <div class="card">
            <div class="title">分子产品</div>
            <div class="con">折扣系数：{{details.clearAccountInfo.molecularProduct.discountRatio}}</div>
          </div>
        </el-col>
<!--        <el-col :span="8">-->
<!--          <div class="card">-->
<!--            <div class="title">基因合成</div>-->
<!--            <div class="con">基础价格：{{details.clearAccountInfo.geneSynthesis.basePrice | amount}} 元</div>-->
<!--          </div>-->
<!--        </el-col>-->
        <el-col :span="8">
          <div class="card">
            <div class="title">Sanger测序</div>
            <div class="con">测序反应基础价：{{details.clearAccountInfo.sungerSeq.basePrice | amount}} 元</div>
          </div>
        </el-col>
      </el-row>
      <table class="table small mt30">
        <tr>
          <th colspan="2" class="text-primary">普通基因合成</th>
          <th colspan="2" class="text-primary">快速基因合成</th>
        </tr>
        <tr>
          <th>基因序列</th>
          <th>单价</th>
          <th>基因序列</th>
          <th>单价</th>
        </tr>
        <tr>
          <td>基因序列≤350bp</td>
          <td>{{normalPrices[0] | amount}}</td>
          <td>基因序列≤300bp</td>
          <td>{{fastPrices[0] | amount}}</td>
        </tr>
        <tr>
          <td>350bp<基因序列≤3kb</td>
          <td>{{normalPrices[1] | amount}}</td>
          <td>300bp<基因序列≤1.2kb</td>
          <td>{{fastPrices[1] | amount}}</td>
        </tr>
        <tr>
          <td>3kb<基因序列≤4.5kb</td>
          <td>{{normalPrices[2] | amount}}</td>
          <td>基因序列>1.2kb</td>
          <td>询价</td>
        </tr>
        <tr>
          <td>4.5kb<基因序列≤6kb</td>
          <td>{{normalPrices[3] | amount}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>6kb<基因序列≤8kb</td>
          <td>{{normalPrices[4] | amount}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>基因序列>8kb</td>
          <td>询价</td>
          <td></td>
          <td></td>
        </tr>
      </table>
      <table class="table small mt30">
        <tr><th colspan="5" class="text-primary">引物合成</th></tr>
        <tr>
          <th>碱基数</th>
          <th>OPC</th>
          <th>PAGE</th>
          <th>HPLC</th>
          <th>微量引物</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index">
          <td>{{item.name}}</td>
          <td>{{item.opcPrice | amount}}{{index === 0 ? '元/条' : '元/bp'}}</td>
          <td>{{item.pagePrice | amount}}{{index === 0 ? '元/条' : '元/bp'}}</td>
          <td rowspan="4" v-show="index === 0">{{item.hplcPrice | amount}}元/条<p class="text-gray9">在脱盐价格基础上另
            加费用</p></td>
          <td rowspan="4" v-show="index === 0">{{item.microPrimersPrice | amount}}元/bp</td>
        </tr>
      </table>
    </section>
    <section>
      <h3 class="title">课题组成员</h3>
      <el-table
        border
        :data="details.members">
        <el-table-column
          prop="realName"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
          label="授权状态">
          <template slot-scope="scope">           
            <!-- <span>{{ scope.row.authorizationFlag ? '已授权' : '未授权' }}</span> -->
             <span>{{ scope.row.authorizationStatus=='UN_AUTH'?'未授权':(scope.row.authorizationStatus=='AUTHED'?'已授权':(scope.row.authorizationStatus=='CANCEL'?'取消授权':'-')) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button type="primary" v-if="!scope.row.authorizationFlag" @click="authorizationHandler(scope.row.id)">授权</el-button>
          </template>
        </el-table-column>-->
      </el-table>
<!--      <div class="tr mt30">-->
<!--        <el-pagination-->
<!--          layout="sizes, prev, pager, next"-->
<!--          :total="100">-->
<!--        </el-pagination>-->
<!--      </div>-->
    </section>
  </div>
</template>

<script>
import { customerGroupsDetail, changeAuthorizeState } from '@/services/api.index'
export default {
  data () {
    return {
      details: {},
      address: '',
      tableData: [],
      fastPrices: [],
      normalPrices: []
    }
  },
  created() {
    this.getCourseGroup()
  },
  methods: {
    async authorizationHandler(id) {
      await changeAuthorizeState(id)
      this.$message.success('授权成功')
      this.getCourseGroup()
    },
    viewContract() {
      window.open(process.env.SHOP_URL + `/article/detail/14_0`)
    },
    // 课程组详情
    getCourseGroup () {
      const researchGroup = this.baseMethods.getLocalObj('memberInfo').researchGroup
      customerGroupsDetail(researchGroup.id).then(res => {
        const { province, city, county, detail } = res.data.workUnit.address
        const generalPrimerSynthesis = res.data.clearAccountInfo ? res.data.clearAccountInfo.generalPrimerSynthesis : null
        res.data.createTime = res.data.createTime.replace('T', ' ').replace('Z', '')
        let coaTemplateName = ''
        switch (res.data.coaTemplate) {
          case 'TSINGKE':
            coaTemplateName = '擎科集团'
            break
          case 'NANJIN_DETAI':
            coaTemplateName = '南京德泰'
            break
          case 'CHANGZHOU_JIYU':
            coaTemplateName = '常州基宇'
            break
          case 'RUIJING':
            coaTemplateName = '瑞晶'
            break
          case 'TAIWAN_SAGON':
            coaTemplateName = '台湾生工'
            break
          case 'NO_LOGO':
            coaTemplateName = '无LOGO'
            break
        }
        res.data.coaTemplateName = coaTemplateName
        this.details = res.data
        this.address = `${province}${city}${county}${detail}`
        this.address = this.address.replace(/null/g, '')
        const opcPrices = generalPrimerSynthesis.opcPrices
        const pagePrices = generalPrimerSynthesis.pagePrices
        const hplcPrice = generalPrimerSynthesis.hplcPrice
        const microPrimersPrice = generalPrimerSynthesis.microPrimersPrice
        let names = ['碱基数≤15bp', '16bp≤碱基数≤59bp', '60bp≤碱基数≤90bp', '碱基数≥90bp']
        for (let i = 0; i < names.length; i++) {
          this.tableData.push({name: names[i], opcPrice: opcPrices[i], pagePrice: pagePrices[i], hplcPrice: hplcPrice, microPrimersPrice: microPrimersPrice})
        }
        this.fastPrices = res.data.clearAccountInfo.geneSynthesis.fastPrices
        this.normalPrices = res.data.clearAccountInfo.geneSynthesis.normalPrices
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/course.vue